import React from 'react'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import Graph from '../../elements/Graphs'
import { graphData } from './constant'

function EnergyGraph(props) {
  const classes = useStyles()
  const data = graphData(props.graphData, props.eventDetails, props.timeZone)
  const eventType = _.get(props.eventDetails, 'type', '')
  const totalVal = eventType === 'BATTERY_DISCHARGE' ? _.get(props.eventDetails, 'Kwh_energy_dispatched', '') : _.get(props.eventDetails, 'Kwh_energy_charged', '')

  return (
    <Box className={classes.contentWrapper} style={{ marginTop: '30px' }}>
      <Typography className={classes.contentTitle}>Energy Graph (Total - {totalVal} kWh)</Typography>
      <Graph data={data} timeZone={props.timeZone} eventDetails={props.eventDetails} />
    </Box>
  )
}

EnergyGraph.defaultProps = {
  graphData: [],
  eventDetails: {}
}

export default EnergyGraph